// extracted by mini-css-extract-plugin
export var cardIcon = "_83-5";
export var cardIconUnframed = "_83-9";
export var checkboxCard = "_83-0";
export var checkboxCardSelected = "_83-4";
export var disabled = "_83-2";
export var interactive = "_83-1";
export var outerBorder = "_83-3";
export var spacerMedium = "_83-8";
export var spacerSmall = "_83-7";
export var spacerXsmall = "_83-6";